import React from 'react';
import { FilterFieldConfig, FilterValues } from '@/hooks/useJsonFilters';
import { FilterOperator, FilterGroup } from '@/lib/utils';
import { cn } from '@/lib/utils';
import {
  FilterForm,
  FilterField,
  FilterClearButton,
  useActiveFilterCount,
} from './FilterForm';

interface FilterBarProps {
  config: FilterFieldConfig[];
  column?: boolean;
  /** Default values to initialize filters with (e.g., from URL params) */
  defaultValues?: FilterValues;
  onFiltersChange?: (params: {
    filterOperator: FilterOperator;
    filterFilterGroups: FilterGroup[];
    values: Record<string, string | Date | undefined>;
  }) => void;
  onHide?: () => void;
}

function FilterBarHeader() {
  const activeFilterCount = useActiveFilterCount();
  
  return (
    <div className="flex items-center justify-between border-b h-[48px] sticky top-0 bg-card1 z-20">
      <div className="flex px-4 items-center gap-3">
        <h2 className="font-semibold">Filter</h2>
        {activeFilterCount > 0 && (
          <span className="inline-flex items-center rounded-full bg-green/40 px-2.5 py-0.5 text-sm font-semibold text-white">
            {activeFilterCount} filters applied
          </span>
        )}
      </div>
    </div>
  );
}

export function FilterBar({ config, column, defaultValues, onFiltersChange }: FilterBarProps) {
  return (
    <FilterForm defaultValues={defaultValues} onFiltersChange={onFiltersChange}>
      <div className="">
        <FilterBarHeader />
        <div
          className={cn(
            'bg-card1 grid grid-cols-1 items-end gap-4 border-b p-4 md:grid-cols-4',
            column ? 'md:grid-cols-1' : 'md:grid-cols-4'
          )}
        >
          {config.map((cfg) => (
            <FilterField
              key={cfg.name}
              className="md:col-span-1"
              {...cfg}
            />
          ))}
        </div>
        <FilterClearButton className="m-4" />
      </div>
    </FilterForm>
  );
}
